module.exports = __webpack_public_path__ + "static/media/Layer Cakes.b79df6ea.jpg";